/**
 * @author Vladislav Urbánek <urbanek.vlada@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import CommunicatorNumber from '../../communicator/number/communicator-number';
import CommunicatorUtility from '../../communicator/utility/communicator-utility';
import ViewerControllerVideo from './viewer-controller-video';

/**
 * @import { IElement } from '../../video'
 * @import BrowserCapabilities from '../../capabilities/browser-capabilities'
 * @import { ViewerControllerFactory } from '../../viewer/controller'
 */

// TODO: Přejmenovat podle konvencí asi na VideoViewerControllerFactory.
/**
 * Továrna na ovladače pro zobrazování video souborů.
 * @implements {ViewerControllerFactory}
 */
export default class ViewerControllerVideoFactory {
  /**
   * @param {BrowserCapabilities} browserCapabilities
   * @param {string | null} poster
   */
  constructor(browserCapabilities, poster) {
    this.browserCapabilities = browserCapabilities;
    this.poster = poster;
  }

  /** @type {ViewerControllerFactory['create']} */
  create(el, settings) {
    return new ViewerControllerVideo(
      this.browserCapabilities,
      /** @type {IElement} */ (el),
      {
        poster: this.poster,
        preloadBlackeningFix:
          CommunicatorUtility.parseBoolean(
            settings.get('generic.viewer.video.preloadBlackeningFix')
          ) ?? false,
        // Experimentálně zjištění, že až po 500 ms lze nastavit původní hodnotu opacity.
        preloadBlackeningFixDelay:
          CommunicatorNumber.fromStringOrNull(
            settings.get('generic.viewer.video.preloadBlackeningFixDelay')
          ) ?? 500,
        seekDisable:
          CommunicatorUtility.parseBoolean(
            settings.get('generic.viewer.video.seekDisable')
          ) ?? false
      }
    );
  }
}
